import * as yup from 'yup';

import { FormErrors } from '@blockpulse3/data/shared';

export const schema = yup.object({
  password: yup
    .string()
    .trim()
    .min(8, FormErrors.PasswordFormat)
    .required(FormErrors.RequiredField),
  confirmPassword: yup
    .string()
    .trim()
    .test(
      'password-confirmation',
      'PASSWORD_MATCH',
      (value, context) => value === context.parent.password,
    )
    .required(FormErrors.RequiredField),
});
